import { useQuery, useQueryClient } from '@tanstack/react-query';
import type { ReactNode } from 'react';

import { isMfaRequired, meQuery } from '../api/me.ts';
import { EnrolTotpScreen } from '../routes/enrol-totp.tsx';

// Wraps everything a signed-in person can reach. The API refuses every authenticated request from
// an account with no authenticator app (ADR-0006 rule 3), so without this the whole app is a wall of
// 403s with nothing to do about them.
//
// It is not a guard. The enforcement is the API's, on every request; this only turns the refusal
// into a screen. Deleting it locks the account out rather than letting it in — which is the right
// way round, and the test for it is in the API, not here.

export function RequireMfa({ children }: { children: ReactNode }) {
  const me = useQuery(meQuery);
  const queryClient = useQueryClient();

  if (me.isPending) return <p className="p-6 text-muted">Loading…</p>;

  if (isMfaRequired(me.error)) {
    return (
      <EnrolTotpScreen
        // The API caches a *confirmed* factor and never a refusal, so the next request sees the
        // enrolment immediately — there is nothing to wait out.
        onEnrolled={() => void queryClient.invalidateQueries({ queryKey: meQuery.queryKey })}
      />
    );
  }

  return <>{children}</>;
}
